// Lattice — a design graph you navigate at the speed of thought.
// Boot: wire the UI to the core, then restore a shared/persisted session.

import "./style.css";

import { bus } from "./core/bus";
import { importFromHash } from "./core/share";
import { clearTrace, exportTrace, getTrace, traceStats } from "./core/telemetry";
import "./ui/toast";
import { initKeyboard } from "./ui/keyboard";
import { initGraph } from "./ui/graph";
import { initLiveDoc, enqueueDecision } from "./ui/livedoc";
import { renderLibrary, initSplash, resumeSession, restoreOnBoot, renderNavPick, newSession, doShare, doExport } from "./ui/splash";
import { copyDoc, closeDoc, downloadDoc, synthesize } from "./ui/docview";
import { closeWhatIf } from "./ui/whatif";
import { runValidation } from "./ui/validate";
import { initTheme, cycleTheme } from "./ui/theme";
import { initTelemetryStat } from "./ui/telemetry-stat";
import { wireRenderBus } from "./ui/render";
import { toast } from "./ui/toast";
import { $ } from "./ui/dom";

// resolved decisions flow into the live doc pane
bus.on("decision", ({ nodeId }) => enqueueDecision(nodeId));

wireRenderBus();
initKeyboard();
initSplash();
renderNavPick();
initLiveDoc();
initGraph();
initTheme();
initTelemetryStat();

// header + overlay buttons (no inline onclick — CSP-friendly)
$("#validateBtn").onclick = () => void runValidation();
$("#shareBtn").onclick = () => void doShare();
$("#exportBtn").onclick = () => doExport();
$("#themeBtn").onclick = () => cycleTheme();
$("#newBtn").onclick = () => newSession();
$("#synthBtn").onclick = () => void synthesize();
$("#docCopyBtn").onclick = () => copyDoc();
$("#docDownloadBtn").onclick = () => downloadDoc();
$("#docCloseBtn").onclick = () => closeDoc();
$("#wiCloseBtn").onclick = () => closeWhatIf();

// Debug/eval surface: session traces are inspectable + exportable from the
// console (used by the eval harness and for bug reports).
declare global { interface Window { LatticeTrace: { get: typeof getTrace; stats: typeof traceStats; export: typeof exportTrace; clear: typeof clearTrace } } }
window.LatticeTrace = { get: getTrace, stats: traceStats, export: exportTrace, clear: clearTrace };

void (async () => {
  // a shared link outranks the local session; both land you mid-graph
  if (await importFromHash()) { resumeSession(); toast("shared design imported — it's yours to explore now"); }
  else if (restoreOnBoot()) resumeSession();
  else renderLibrary();
})();
